import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setShowAddBuyer } from 'src/app/redux/actions/options.action';
import { setEditAll, setIndexToEditValidation, setIsOrderReturned, setOrdersSelected, setValidationOrdersToGenerate } from 'src/app/redux/actions/order.action';
import { isBuyerOfGrassiGroup, isBuyerWithNoSpecificPort, StructBuyerProform, canYouBuyCommodities, canYouBuyHughes, isValidOrderByBuyer, applyOrderCommissionAndPort } from '@shared-logic/subjects';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { COMMODITIES_CODE, COMMODITIES_CODE_SELLER, HUGHES_CODE_BUYER, HUGHES_CODE_SELLER } from '@shared-logic/subjects';
import { typeCoins } from '@shared-logic/prices';
import { orderType } from 'src/app/shared/dict/orders';
import { sellerWithData } from 'src/app/shared/dict/seller-with-data';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order, orderOriginConst, orderStatusConst } from '@shared-logic/orders';
import {
  isPurchaseMethodGateBlocked, mapBuyerPurchaseMethodDefault, PURCHASE_METHOD_PENDING,
  PurchaseMethodGateStatus, PurchaseMethodPair, resolvePurchaseMethodDefault
} from '@shared-logic/purchase-method';
import { User } from '@shared-logic/user/user.interface';
import { OrderValidator } from 'src/app/shared/order';
import { FilterWithOutContractStatus } from 'src/app/shared/pipes/filter/filterWithOutContractStatus.pipe';
import { getArrowDirectionByBool } from 'src/app/shared/validator.checker';
import { IntegrationIBMService } from 'src/app/shared/services/integration-ibm.service';
import { getPlaceOfDeliveryIBM } from '@shared-logic/locations';
import { fieldType } from 'src/app/shared/const/options';
import { ACT_PROFORM, isAllValidInProform } from '../../form/form-proform-buyer/form-proform-buyer.component';
import {
  PurchaseMethodDefaultClassification, PurchaseMethodValidationResult, PURCHASE_METHOD_RESPONSE
} from '@shared-logic/integration-ibm';
import { CREATION_TYPE_CONST } from '@shared-logic/prices';
import { isCramdownApplicable, isCramdownProductMismatch } from '@shared-logic/subjects/buyers-validations';

@Component({
  selector: 'app-add-buyer',
  templateUrl: './add-buyer.component.html',
  styleUrls: ['./add-buyer.component.scss', './../slide-card.scss']
})
export class AddBuyerComponent implements OnInit, OnDestroy {
  user!: User;

  orders: Order[] = [];
  ordersSelected: Order[] = [];

  ordersCheck: Order[] = [];
  isClicked: boolean = false;
  buyerSelectedField: number = -1;
  purchaseMethodSelectedField: number = -1;
  purchaseMethodIsEditable: boolean = true;
  purchaseMethodIsVisible: boolean = true;
  /* Drives the field's explanatory note only, decoupled from purchaseMethodIsEditable
  (which this component also ANDs with "not mid-validation" for the actual input). */
  purchaseMethodIsFasonContract: boolean = false;

  typeDolarSelectedField: number = -1;
  grouperCodeSelectedField: number = -1;

  //Acordion
  indexToOpen: number = -1;

  //Detect click
  wasInside = false;
  count = 0;
  clickInClose = false;

  //CONST
  SELLERS: any = sellerWithData;
  ORDER_TYPES: any = orderType;

  //orderToChangeWithProform!:Order; //Orden antes de cambiar las cosas

  orderToAnalizateProform!: Order | null;
  orderOriginal!: Order | null;
  //Se actualiza con las siguientes funciones: selectAllOrders, getOrdersCheck, addOrRemoveOrder
  structBuyer!: StructBuyerProform | null;
  actionProform: string = '';

  buyerManuallyModified: boolean = false;
  purchaseMethodManuallyModified: boolean = false;
  grouperManuallyModified: boolean = false;

  //---------- Validation PurchaseMethod ----------\\
  /* Single state instead of four independent booleans (ADR-0001/ADR-0002, R4): null
  means nothing to report (idle, or a value not yet checked), so the field's own
  template can never end up showing two contradictory leyendas at once. */
  public purchaseMethodStatus: PurchaseMethodGateStatus | null = null;
  public purchaseMethodMessageError: string | null = null;
  public isAutocompletingPurchaseMethod: boolean = false;
  /* The pair purchaseMethodStatus was earned for (R5): set once, when the query for it
  starts, so a result that arrives after the operator changed buyer or purchase method
  can be recognised by isPurchaseMethodGateBlocked as belonging to a combination that is
  no longer on screen, instead of authorising the new one. */
  private purchaseMethodVerdictPair: PurchaseMethodPair | null = null;
  public readonly PURCHASE_METHOD_STATUS = PURCHASE_METHOD_RESPONSE;
  public readonly PURCHASE_METHOD_PENDING = PURCHASE_METHOD_PENDING;


  private orders$!: Subscription;
  private ordersSelected$!: Subscription;
  private user$!: Subscription;
  private purchaseMethodDefaultRequestId = 0;
  private purchaseMethodValidateRequestId = 0;
  constructor(private store: Store<appState>, private router: Router, private orderV: OrderValidator,
    private IBM: IntegrationIBMService) { }

  ngOnInit(): void {

    this.orders$ = this.store.select('order', 'orderBoard', 'all').subscribe(orders => {
      this.orders = orders;
    })

    this.ordersSelected$ = this.store.select('order', 'edit', 'ordersEdit').subscribe(orders => {
      this.ordersSelected = orders;
    })

    this.user$ = this.store.select('usuario').subscribe(userR => {
      this.user = userR;
    })


    //Seteamos en true para no cambiar el estado mientras está agregando un comprador
    this.store.dispatch(setIsOrderReturned({ isOrderReturned: true }));

    this.getOrdersCheck();
  }

  ngOnDestroy(): void {
    this.orders$?.unsubscribe();
    this.ordersSelected$?.unsubscribe();
    this.user$?.unsubscribe();

    //Seteamos en false para volver a cambiar el estado mientras está agregando un comprador
    this.store.dispatch(setIsOrderReturned({ isOrderReturned: false }));
  }

  checkClose(ordersSelected: Order[], isLoader: boolean) {
    if (ordersSelected.length == 0 && !isLoader) {
      this.closeAddBuyer();
    }
  }

  isOrderCheck(order: Order) {
    return this.orderV.isOrderInOrderList(order, this.ordersCheck);
  }

  showTypeDolar() {
    const quantOrdersCheck = this.ordersCheck.length;
    if (quantOrdersCheck == 0) { return true; }
    try {
      for (let i = 0; i < quantOrdersCheck; i++) {
        //Si es en dolares o tiene indicadores, pide que se seleccione el tipo de dolar
        if (this.ordersCheck[i]?.price?.typeCoin == typeCoins.USD || this.ordersCheck[i]?.price?.indicators?.length > 0) {
          throw new Error();
        }
      }
      return false;
    } catch (err) {
      return true;
    }
  }

  getSellerData(order: Order) {
    return this.orderV.getSellerNameAndTons(order);
  }

  addOrRemoveOrder(order: Order) {
    let indexOfOrder = this.orderV.indexOfOrder(this.ordersCheck, order);
    if (indexOfOrder != -1) {
      this.ordersCheck.splice(indexOfOrder, 1);
    } else {
      this.ordersCheck.push(order);
    }
    this.setOrderToProform();
  }

  getStringOrders(number: number) {
    return number == 1 ? '1 orden seleccionada' : (number + ' ordenes seleccionadas');
  }

  setIndexToOpen(index: number) {
    this.indexToOpen = (this.indexToOpen == index ? -1 : index);
  }

  getArrowDirection(index: number) {
    return getArrowDirectionByBool(this.indexToOpen == index);
  }

  showMessageEdit: boolean = false;
  goToValidations() {
    if (this.ordersCheck.length > 0) {
      this.showMessageEdit = false;
      let validationOrders = this.getValidationsOrderWithFields(
        this.ordersCheck,
        this.buyerSelectedField,
        this.purchaseMethodSelectedField,
        this.typeDolarSelectedField,
        this.grouperCodeSelectedField
      );
      this.store.dispatch(setValidationOrdersToGenerate({ orders: validationOrders }));
      this.store.dispatch(setIndexToEditValidation({ indexToEdit: 0 }));

      const url = "/" + NAVEGATION.ORDER_VALIDATION
      this.router.navigate([url]);
      this.closeAddBuyer();
    } else {
      this.showMessageEdit = true;
    }
  }

  //Dadas las ordenes seleccionadas y los campos que ya editó el usuario, 
  //setea los valores para que aparezcan completados en la sección de editar
  getValidationsOrderWithFields(orders: Order[], buyer: number, purchaseMethod: number, typeDolar: number, grouperCode: number) {
    let validationsOrders: Order[] = [];
    orders.forEach(order => {
      let validationOrder: Order = JSON.parse(JSON.stringify(order));
      validationOrder.price.observations.buyer = buyer;
      validationOrder.purchaseMethod = purchaseMethod;
      validationOrder.price.typeDolar = typeDolar;
      validationOrder.price.grouperCode = grouperCode;

      if (this.requirePlaceOfDelivery()) {
        validationOrder.price.placeOfDelivery = this.orderToAnalizateProform!.price.placeOfDelivery;
      }

      validationsOrders.push(validationOrder);
    })
    return validationsOrders;
  }

  applyChanges() {
    this.isClicked = true;
    //Edit orders
    if (this.buyerSelectedField != -1 && this.ordersCheck.length > 0) {
      this.editOrdersChecks();
    }

    if (this.ordersSelected.length == 0) {
      this.closeAddBuyer();
    }
  }

  editOrdersChecks() {
    let ordersEdit: Order[] = [];
    let newValidationsOrdersSelected: Order[] = JSON.parse(JSON.stringify(this.ordersSelected));
    let nroOfCall = 1;
    this.ordersCheck.forEach(order => {

      let orderEdit: Order = JSON.parse(JSON.stringify(order)); //Parseamos order
      const sellerCode = orderEdit.sellerData.codeS;
      orderEdit.price.observations.buyer = this.buyerSelectedField; //Editamos buyer
      orderEdit.purchaseMethod = this.purchaseMethodSelectedField; //Editamos forma de compra
      orderEdit.price.typeDolar = this.typeDolarSelectedField; //Editamos typeDolar
      orderEdit.price.grouperCode = this.grouperCodeSelectedField; //Editamos codigo agrupador

      if (this.requirePlaceOfDelivery()) {
        orderEdit.price.placeOfDelivery = this.orderToAnalizateProform!.price.placeOfDelivery;
      }

      orderEdit = this.editOrderByActionAndBuyer(orderEdit, this.orderToAnalizateProform, this.actionProform);

      //Guardamos el estado de la orden
      orderEdit.statusOrder = orderStatusConst.CONFIRM;

      //Lo siguiente es el seteo de las comisiones que también debe ejecutarse cuando editan una orden
      //está en el componente de details-validation/details.component.ts
       orderEdit = applyOrderCommissionAndPort(
         orderEdit,
         sellerCode,
        this.buyerSelectedField,
         (order, type) => this.orderV.getCommisionByOrder(order, type)
       );

       orderEdit = this.normalizeCramdown(orderEdit);

      nroOfCall = isBuyerOfGrassiGroup(this.buyerSelectedField) ? 1 : 2;

      ordersEdit.push(orderEdit); //Añadimos a la lista de orders editados

      //Quitamos la orden de las ordenes validadas;
      let indexOrder = this.orderV.indexOfOrder(newValidationsOrdersSelected, order);
      if (indexOrder != -1) {
        newValidationsOrdersSelected.splice(indexOrder, 1);
      }
    })

    this.IBM.createContracts(ordersEdit, nroOfCall, this.user); //ACTUALIZATE
    this.store.dispatch(setValidationOrdersToGenerate({ orders: newValidationsOrdersSelected }));
    this.store.dispatch(setOrdersSelected({ orders: [] }))
    this.ordersCheck = [];
     this.isClicked = false;
   }

  private normalizeCramdown(order: Order): Order {
    const creationType = isCramdownApplicable(
      order.sellerData.codeS,
      order.price.observations.buyer,
      order.price.productName
    )
      ? CREATION_TYPE_CONST.CRAMDOWN
      : CREATION_TYPE_CONST.STANDARD;

    if (order.price.creationType === creationType) {
      return order;
    }

    return {
      ...order,
      price: { ...order.price, creationType },
    };
  }

  closeAddBuyer() {
    this.clickInClose = true;
    this.count = 0;
    this.store.dispatch(setShowAddBuyer({ isShowAddBuyer: false }));
    this.store.dispatch(setEditAll({ editAll: false }));
  }

  saveBuyerSelected(event: any) {
    const index = Number(event);
    this.buyerSelectedField = index;
    this.buyerManuallyModified = true;
    // A new buyer must receive a fresh COMODEF suggestion instead of reusing
    // the purchase method that belonged to the previous buyer.
    this.purchaseMethodManuallyModified = false;
    this.purchaseMethodSelectedField = -1;
    this.purchaseMethodDefaultRequestId++;
    this.actualizateStructBuyer(this.orderToAnalizateProform);
    this.resolvePurchaseMethod();
  }

  saveNewOrderWithProform(event: { action: string, newOrder: Order | null }) {
    this.actionProform = event.action;

    if (this.actionProform == ACT_PROFORM.IGNORE) {
      this.actualizateStructBuyer(this.orderOriginal, true);
    }
  }

  saveDolarTypeSelected(event: any) {
    const index = Number(event);
    this.typeDolarSelectedField = index;
  }

  savePurchaseMethodSelected(event: any) {
    const index = Number(event);
    this.purchaseMethodSelectedField = index;
    this.purchaseMethodManuallyModified = true;
    this.validatePurchaseMethodInAddBuyer();
  }

  saveGrouperCodeSelected(event: any) {
    const index = Number(event);
    this.grouperCodeSelectedField = index;
    this.grouperManuallyModified = true;
  }

  getBuyerSelected() {
    return this.buyerSelectedField;
  }

  getDolarTypeSelected() {
    if (this.typeDolarSelectedField <= 0) {
      this.typeDolarSelectedField = 1;
    }
    return this.typeDolarSelectedField;
  }

  getPurchaseMethodSelected() {
    return this.purchaseMethodSelectedField;
  }

  getGrouperCodeSelected() {
    return this.grouperCodeSelectedField;
  }

  getOrdersCheck() {
    setTimeout(() => {
      this.ordersCheck = [];
      this.buyerManuallyModified = false;
      this.purchaseMethodManuallyModified = false;
      this.grouperManuallyModified = false;
      if (this.ordersSelected.length > 0) {
        this.ordersCheck = this.getOrdersSelectedWithPipe(); // Select all initially
        this.setOrderToProform();
      }
    }, 100);
  }

  isAllChecked() {
    return this.ordersCheck?.length == this.getOrdersSelectedWithPipe()?.length;
  }

  getOrdersSelectedWithPipe() {
    const pipe = new FilterWithOutContractStatus();
    const filteredOrders = pipe.transform(this.ordersSelected);
    // Ordenar por fecha de creación de menor a mayor (más antigua a más nueva)
    const sortedOrders = filteredOrders.sort((a, b) => {
      const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
      const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
      return dateA - dateB;
    });

    return sortedOrders;
  }

  selectAllOrders() {
    this.ordersCheck = this.isAllChecked() ? [] : this.getOrdersSelectedWithPipe();
    this.setOrderToProform();
  }

  setOrderToProform() {
    const order = this.ordersCheck.length > 0 ? this.ordersCheck[0] : null;
    this.actualizateStructBuyer(order);
    this.orderOriginal = order;

    // Calculate common values for checked orders
    this.calculateCommonFields();
  }

  calculateCommonFields() {
    const previousBuyer = this.buyerSelectedField;
    const previousPurchaseMethod = this.purchaseMethodSelectedField;

    if (this.ordersCheck.length === 0) {
      this.buyerSelectedField = -1;
      this.purchaseMethodSelectedField = -1;
      this.purchaseMethodIsVisible = true;
      this.purchaseMethodIsEditable = true;
      this.grouperCodeSelectedField = -1;
      this.clearPurchaseMethodValidationState();
      return;
    }

    // --- Buyer Calculation ---
    if (!this.buyerManuallyModified) {
      try {
        // Prioritize onlySell
        const firstOnlySell = Array.isArray(this.ordersCheck[0].buyer.onlySell) ? this.ordersCheck[0].buyer.onlySell[0] : this.ordersCheck[0].buyer.onlySell;
        const allSameOnlySell = firstOnlySell > 0 && this.ordersCheck.every(o => {
          const os = Array.isArray(o.buyer.onlySell) ? o.buyer.onlySell[0] : o.buyer.onlySell;
          return os == firstOnlySell;
        });

        if (allSameOnlySell) {
          this.buyerSelectedField = firstOnlySell;
        } else {
          // Check buyer observation
          const firstBuyer = this.ordersCheck[0].price.observations.buyer;
          const allSameBuyer = firstBuyer > 0 && this.ordersCheck.every(o => o.price.observations.buyer == firstBuyer);

          if (allSameBuyer) {
            this.buyerSelectedField = firstBuyer;
          } else {
            // If mixed, use Commodities only if default logic allows, otherwise -1 (empty)
            // Defaulting to empty (-1) is safer when mixed.
            // However, the original logic defaulted to COMMODITIES_CODE if "nothing else applied"
            // We can check if *any* order allows default. Or strictly default to empty if not matching.
            // User said: "Coloca el valor si todas las seleccionadas son iguales. Sino, irá vacío."
            // So: empty if not equal.

            // Exception: Original logic had a fallback to COMMODITIES_CODE. 
            // But "Sino, irá vacío" implies we respect the mismatch.
            this.buyerSelectedField = -1;
          }
        }
      } catch (e) {
        this.buyerSelectedField = -1;
      }
    }

    // --- Purchase Method Calculation ---
    if (!this.purchaseMethodManuallyModified) {
      try {
        const firstPurchaseMethod = this.ordersCheck[0].purchaseMethod;
        const allSamePurchaseMethod =
          firstPurchaseMethod > 0 &&
          this.ordersCheck.every(o => o.purchaseMethod == firstPurchaseMethod);

        this.purchaseMethodSelectedField = allSamePurchaseMethod ? firstPurchaseMethod : -1;
      } catch (e) {
        this.purchaseMethodSelectedField = -1;
      }
    }

    this.resolvePurchaseMethod();

    // --- Grouper Code Calculation ---
    if (!this.grouperManuallyModified) {
      try {
        const firstGrouper = this.ordersCheck[0].price.grouperCode;
        const allSameGrouper = firstGrouper > 0 && this.ordersCheck.every(o => o.price.grouperCode == firstGrouper);

        if (allSameGrouper) {
          this.grouperCodeSelectedField = firstGrouper;
        } else {
          this.grouperCodeSelectedField = -1;
        }
      } catch (e) {
        this.grouperCodeSelectedField = -1;
      }
    }

    const defaultedValuesChanged =
      previousBuyer != this.buyerSelectedField ||
      previousPurchaseMethod != this.purchaseMethodSelectedField;

    if (!this.purchaseMethodIsVisible || this.buyerSelectedField <= 0 || this.purchaseMethodSelectedField <= 0) {
      this.clearPurchaseMethodValidationState();
      return;
    }

    if (defaultedValuesChanged && (!this.buyerManuallyModified || !this.purchaseMethodManuallyModified)) {
      this.validatePurchaseMethodInAddBuyer();
    }
  }

  actualizateStructBuyer(newOrder: Order | null, notReiniciateAction?: boolean) {
    this.orderToAnalizateProform = newOrder;
    if (this.orderToAnalizateProform && this.buyerSelectedField > 0) {
      this.structBuyer = isValidOrderByBuyer(this.orderToAnalizateProform, this.buyerSelectedField);
      this.actionProform = notReiniciateAction ? this.actionProform : '';
    } else {
      this.structBuyer = null;
      this.actionProform = '';
    }
  }

  actualizateOrderPlaceOfDelivery(newOrder: Order | null) {
    this.orderToAnalizateProform = newOrder;
  }

  /**
   * Given an order, an order with the proformas applied and an action.
   * We analyze the action. If it is autocorrect, we assign the values of the proformas. 
   * If it is ignore, we do nothing.
   * @param order 
   * @param orderProform 
   * @param action 
   * @returns order
   */
  editOrderByActionAndBuyer(order: Order, orderProform: Order | null, action: string): Order {
    let orderEdit: Order = JSON.parse(JSON.stringify(order));
    if (action == ACT_PROFORM.AUTOCORRECT && orderProform) {
      orderEdit.price.quality = orderProform.price.quality;
      orderEdit.price.placeOfDelivery = orderProform.price.placeOfDelivery;
      orderEdit.price.wayPay = orderProform.price.wayPay;
    }

    return orderEdit;
  }


  isDisabledButton() {
    if (this.buyerSelectedField == COMMODITIES_CODE) {
      let flag = 0;
      this.ordersCheck.forEach(order => {
        if (!canYouBuyCommodities(order)) {
          flag++;
        }
      });

      return flag > 0;

    } else if (this.buyerSelectedField == HUGHES_CODE_BUYER) {
      let flag = 0;
      this.ordersCheck.forEach(order => {
        if (!canYouBuyHughes(order)) {
          flag++;
        }
      });

      return flag > 0;

    } else {
      return false;
    }
  }

  isInvalidOrderWithBuyer() {
    let flag = 0;
    this.ordersCheck.forEach(order => {
      if (!isValidOrderByBuyer(order, this.buyerSelectedField)) {
        flag++;
      }
    });

    return flag > 0;
  }

  isExensionDeIVAWithCommodities() {
    let flag = 0;
    this.ordersCheck.forEach(order => {
      if ((order.price.businessParticularities.respectVatException == 1 && isBuyerOfGrassiGroup(order.price.observations.buyer))) {
        flag++;
      }
    });

    return flag > 0;
  }

  isButtonDisabled() {
    return this.getButtonDisabledChecks().isButtonDisabled;
  }

  getButtonDisabledChecks() {
    const checks = {
      noOrdersSelected: this.ordersCheck.length == 0,
      missingBuyer: this.buyerSelectedField <= 0,
      // Kept for the "falta completar" message (add-buyer.component.html), but no longer
      // part of the OR chain below: purchaseMethodBlocked already covers an empty field,
      // since isPurchaseMethodGateBlocked rejects an unset or invalid purchaseMethod.
      missingPurchaseMethod: this.purchaseMethodIsVisible && this.purchaseMethodSelectedField <= 0,
      /* The single definition of "does forma de compra block this action" (R1, R5):
      blocks unless the value is set, the integration approved it, and that approval
      belongs to the pair currently on screen. A pending check, an unavailable
      integration, a rejected pair, or a verdict earned by a different pair all block. */
      purchaseMethodBlocked: this.purchaseMethodIsVisible && isPurchaseMethodGateBlocked(
        { buyerCode: this.buyerSelectedField, purchaseMethod: this.purchaseMethodSelectedField },
        { pair: this.purchaseMethodVerdictPair, status: this.purchaseMethodStatus ?? PURCHASE_METHOD_PENDING }
      ),
      missingTypeDolar: this.typeDolarSelectedField <= 0,
      invalidBuyerOrigin: this.isDisabledButton(),
      vatExceptionWithCommodities: this.isExensionDeIVAWithCommodities(),
      missingGrouperCode: this.grouperCodeSelectedField < 0,
      pendingProformAction: this.isPendingProformAction(),
      invalidPlaceOfDelivery: this.isPlaceOfDeliveryInvalid(),
      hasUsableProform: this.hasUsableProform(),
      placeOfDeliveryPort: this.orderToAnalizateProform?.price.placeOfDelivery?.port ?? 0,
      placeOfDeliveryZone: this.orderToAnalizateProform?.price.placeOfDelivery?.zone ?? 0,
      // Hard block (R3, R7): any marked order left in a Cramdown-account + non-Soja-product
      // conflict blocks the whole batch, not just that order. Additive to isCramdownApplicable
      // (R8) -- never replaces normalizeCramdown(), only gates the button.
      cramdownProductMismatch: this.ordersCheck.some(order => isCramdownProductMismatch(
        order.sellerData.codeS,
        [this.buyerSelectedField],
        order.price.productName
      )),
      isButtonDisabled: false,
    };

    checks.isButtonDisabled =
      checks.noOrdersSelected ||
      checks.missingBuyer ||
      checks.purchaseMethodBlocked ||
      checks.missingTypeDolar ||
      checks.invalidBuyerOrigin ||
      checks.vatExceptionWithCommodities ||
      checks.missingGrouperCode ||
      checks.pendingProformAction ||
      checks.invalidPlaceOfDelivery ||
      checks.cramdownProductMismatch;

    return checks;
  }

  isPendingProformAction() {
    return this.hasUsableProform() && !isAllValidInProform(this.structBuyer) && !this.actionProform;
  }

  hasUsableProform() {
    if (!this.structBuyer) {
      return false;
    }

    const fields = [
      this.structBuyer.product,
      this.structBuyer.quality,
      this.structBuyer.place,
      this.structBuyer.wayPay,
    ];

    const isStructVoid = fields.every(field =>
      !field.isValid &&
      field.default <= 0 &&
      field.arrayValids.length == 0
    );

    return !isStructVoid;
  }

  getBaseOrderForPlaceOfDeliveryRequirement() {
    return this.orderOriginal ?? this.orderToAnalizateProform;
  }

  requirePlaceOfDelivery() {
    const baseOrder = this.getBaseOrderForPlaceOfDeliveryRequirement();
    return !!(this.buyerSelectedField > 0 &&
      baseOrder &&
      getPlaceOfDeliveryIBM(baseOrder) == 0 &&
      !isBuyerWithNoSpecificPort(this.buyerSelectedField) &&
      !this.hasUsableProform());
  }

  isPlaceOfDeliveryInvalid() {
    return this.requirePlaceOfDelivery() && (this.orderToAnalizateProform?.price.placeOfDelivery.port ?? 0) <= 0;
  }

  validatePurchaseMethodInAddBuyer() {
    const buyerCode = this.buyerSelectedField;
    if (buyerCode <= 0 || this.purchaseMethodSelectedField <= 0) {
      this.clearPurchaseMethodValidationState();
      return;
    }

    /* Guards against a retry (R9) racing an already in-flight validation: whichever call
    started last wins, so a stale response arriving after a retry can never overwrite the
    retry's own result. Same pattern as purchaseMethodDefaultRequestId above. */
    const requestId = ++this.purchaseMethodValidateRequestId;
    this.purchaseMethodStatus = PURCHASE_METHOD_PENDING;
    this.purchaseMethodMessageError = null;
    /* Fixed once, at the moment this query starts: the pair the eventual verdict will
    belong to (R5). If the operator changes buyer or purchase method before it resolves,
    isPurchaseMethodGateBlocked compares this against the pair on screen and keeps
    blocking regardless of what the stale response later claims. */
    this.purchaseMethodVerdictPair = { buyerCode, purchaseMethod: this.purchaseMethodSelectedField };

    /* The classified result is stored as-is: valid, invalid and unavailable stay three
    distinct states here, so the field can show IBM's own rejection message (ADR-0001)
    instead of a boolean pair that used to collapse invalid into unavailable. */
    this.orderV.getValidatePurchaseMethod(buyerCode, this.purchaseMethodSelectedField).then((result: PurchaseMethodValidationResult) => {
      if (requestId !== this.purchaseMethodValidateRequestId) {
        return;
      }
      this.purchaseMethodStatus = result.status;
      this.purchaseMethodMessageError = result.messageError;
    });
  }

  private resolvePurchaseMethod(): void {
    const orders = this.ordersCheck;
    if (orders.length === 0) {
      this.purchaseMethodIsVisible = true;
      this.purchaseMethodIsEditable = true;
      this.purchaseMethodIsFasonContract = false;
      return;
    }

    const isFasonContract = orders.some(order => order.price.businessParticularities?.isFasonContract === true);
    const onlySellValue = orders[0].buyer?.onlySell;
    const onlySell = Array.isArray(onlySellValue) ? Number(onlySellValue[0]) : Number(onlySellValue);
    const resolution = resolvePurchaseMethodDefault({
      isFasonContract,
      onlySell: Number.isNaN(onlySell) ? 0 : onlySell,
      hasBuyerDefault: false,
    });

    // The field is mandatory for every selected order. Only Fason contracts
    // keep the resolved value locked; other buyers may edit it manually.
    this.purchaseMethodIsVisible = true;
    this.purchaseMethodIsEditable = isFasonContract ? resolution.isEditable : true;
    this.purchaseMethodIsFasonContract = isFasonContract;

    if (isFasonContract) {
      this.purchaseMethodSelectedField = resolution.value;

      /* Fasón forces the value but never blocked on it being validated (finding from
      the user testing this scope): the field being locked is not the same as the
      buyer being eligible for it. Validate whenever there's a buyer and the pair
      hasn't already been checked, mirroring the dedup the non-Fasón path below gets
      for free from "purchaseMethodSelectedField > 0" short-circuiting further calls. */
      const pair = { buyerCode: this.buyerSelectedField, purchaseMethod: resolution.value };
      const alreadyChecked = this.purchaseMethodVerdictPair?.buyerCode === pair.buyerCode &&
        this.purchaseMethodVerdictPair?.purchaseMethod === pair.purchaseMethod;
      if (pair.buyerCode > 0 && !alreadyChecked) {
        this.validatePurchaseMethodInAddBuyer();
      }
      return;
    }

    if (this.buyerSelectedField <= 0 || this.purchaseMethodManuallyModified) {
      return;
    }

    if (this.purchaseMethodSelectedField > 0) {
      return;
    }

    this.queryDefaultPurchaseMethod();
  }

  /* Shared by the initial autocomplete (resolvePurchaseMethod) and the retry control
  (R9): both need the exact same request-id-guarded query, so a stale response from
  either caller cannot overwrite a newer one. */
  private queryDefaultPurchaseMethod(): void {
    const requestId = ++this.purchaseMethodDefaultRequestId;
    this.purchaseMethodStatus = PURCHASE_METHOD_PENDING;
    this.purchaseMethodMessageError = null;
    this.isAutocompletingPurchaseMethod = true;

    this.orderV.getDefaultPurchaseMethod(this.buyerSelectedField).then((classification: PurchaseMethodDefaultClassification) => {
      if (requestId !== this.purchaseMethodDefaultRequestId) {
        return;
      }

      /* A failed default lookup is a degraded dependency blocking the action (R8), and
      it must never claim the purchase method is invalid: that was the semantic lie the
      previous flag pair left in place on purpose, only hidden by the template excluding
      the rejection message whenever the connection flag was also set (Sprint 1
      recommendation, closed here per ADR-0001). */
      if (classification.status == PURCHASE_METHOD_RESPONSE.UNAVAILABLE) {
        this.purchaseMethodStatus = PURCHASE_METHOD_RESPONSE.UNAVAILABLE;
        this.isAutocompletingPurchaseMethod = false;
        return;
      }

      const defaultValue = mapBuyerPurchaseMethodDefault(classification.rawValue ?? '');
      // COMODEF default applies regardless of onlySell: the field is always
      // visible and mandatory in add-buyer, so an IBM-returned default must
      // be honored even when onlySell is 0.
      this.purchaseMethodSelectedField = defaultValue.hasDefault ? defaultValue.value : -1;
      // No default (R7) is a successful answer: nothing to report on the field, only
      // "missing" if it stays empty -- handled by the wrapper's own message, not here.
      this.purchaseMethodStatus = null;
      this.isAutocompletingPurchaseMethod = false;
      if (this.purchaseMethodSelectedField > 0) {
        this.validatePurchaseMethodInAddBuyer();
      }
    });
  }

  /* R9: the unavailable state's only way out short of reloading. Which query to retry
  depends on whether the field has a value, not on which query failed originally -- the
  operator may have typed a value by hand after a failed autocomplete. */
  retryPurchaseMethodQuery(): void {
    if (this.purchaseMethodSelectedField <= 0) {
      if (this.buyerSelectedField > 0) {
        this.queryDefaultPurchaseMethod();
      }
      return;
    }

    this.validatePurchaseMethodInAddBuyer();
  }

  clearPurchaseMethodValidationState() {
    this.purchaseMethodStatus = null;
    this.purchaseMethodMessageError = null;
    this.purchaseMethodVerdictPair = null;
    this.isAutocompletingPurchaseMethod = false;
  }
}
